'use strict';

export class DialogFactory {
	static $inject = ['mx.shell.DetailsView', 'mx.SolutionBuilderAgent.ContentWidgetService'];
	constructor(DetailsView, contentWidgetService) {
		this.contentWidgetService = contentWidgetService;
		this.DetailsView = DetailsView;
		this.previewUiActionGroup = ['is_printable'];
		this.dialogsActionGroup = [];
	}

	_createDialog(context, view, options) {
		const dialogView = new this.DetailsView({
			id: options.id || context._id, //TODO: check the using and refactor view.id and view.type
			type: context._type,
			name: context._name,
			displayName: context._displayName, // || i18n.get('solutionBuilderAgent.common.edit'),
			context: context,

			template: '<mx-dialog-view data-view="vm.view"></mx-dialog-view>',

			widgetId: view.Id,
			widgetName: view.Name,
			mergeDisabled: view.MergeDisabled,
			headerIcon: view.EntityIcon,
			headerColor: view.EntityColor,
			headerTitle: view.EntityDisplayName,
			hideHeaderTitle: view.HideHeaderTitle,
			purpose: view.Purpose,

			dialogType: options.dialogType,
			alwaysFullScreen: options.alwaysFullScreen,
			isRefreshable: options.isRefreshable,
			presetFields: options.presetFields,

			hideActions: options.hideActions,
			isSingleView: options.isSingleView,
			readOnly: options.readOnly,

			uiActionGroup: options.uiActionGroup,

			dialogInsteadOfPreview: options.dialogInsteadOfPreview,

			controllerParams: options.controllerParams,
			selectedObjects: options.selectedObjects,

			locals: {
				context: context,
				entityDisplayName: view.EntityDisplayName,

				outerContext: options.outerContext,
				widgetId: view.Id,

				hideActions: options.hideActions,
				isSingleView: options.isSingleView,
				readOnly: options.readOnly,
			},
		});
		this.contentWidgetService.setViewUrl(dialogView, view.Id, context);

		dialogView.locals.view = dialogView;
		return dialogView;
	}

	_getUiActionGroups(objectType) {
		// TODO: Remove or rework when localizaion of service-based dialogs is implemented.
		const groups = this.dialogsActionGroup.slice();

		if (objectType.indexOf('service_') !== 0) {
			groups.push('localizable_view');
		}

		return groups;
	}

	createPreview(context, view, options = {}) {
		Object.assign(options, {
			dialogType: mx.SolutionBuilderAgent.ContentWidgetDialogAction.Preview,
			alwaysFullScreen: false,
			isRefreshable: true,
			uiActionGroup: this.previewUiActionGroup,
		});
		return this._createDialog(context, view, options);
	}

	createEditDialog(context, view, options = {}) {
		Object.assign(options, {
			dialogType: mx.SolutionBuilderAgent.ContentWidgetDialogAction.Edit,
			alwaysFullScreen: true,
			isRefreshable: true,
			uiActionGroup: this._getUiActionGroups(context._type),
		});
		return this._createDialog(context, view, options);
	}

	createNewDialog(context, view, options = {}) {
		Object.assign(options, {
			dialogType: mx.SolutionBuilderAgent.ContentWidgetDialogAction.New,
			alwaysFullScreen: true,
			uiActionGroup: this._getUiActionGroups(context._type),
		});
		return this._createDialog(context, view, options);
	}
}
